import { Observable } from 'rxjs/Observable';

import { Injectable } from '@angular/core';
import { UrlServices } from '../url.services';
import { GenericService, METHODS } from '../services.util';

/**
 * UserService manages our current user
 */
@Injectable()
export class IncentivosService {

  urlServices: UrlServices = new UrlServices();


  constructor(public _genericService: GenericService) {
  }

  getBestByBranch(date: string): Observable<any> {
    const {brokerId, url} = this.urlServices.getUrlBestByBranch();
    const bodyIncent = {date};
    return this._genericService.genericCallServices(METHODS.POST, `${url}?brokerId=${brokerId}`, bodyIncent, null, null);
  }

  getCatalogsBasic(name: string, countryId: string, parentId?): Observable<any> {
    let codeParenteId = '';
    if (parentId) {
      codeParenteId = '&parentId=' + parentId;
    }
    return this._genericService.genericCallServices(METHODS.GET,
      `${this.urlServices.domainCatalogs}/${name}/basic?country=${countryId}${codeParenteId}&idToken=52fa1bff326ed4d5e05e7f9f23f1ea50`);
  }

}
